import React from 'react';
import PropTypes from 'prop-types';
import LabelHasRiskClassReductionTextComponent from './LabelHasRiskClassReductionTextComponent';
import ShowComponent from '../../hocs/ShowComponent';

@ShowComponent
class LabelHasRiskClassReductionLogoComponent extends React.Component {
  render() {
    const {
      forceAutoRiskClassReduction,
      selectedLabelHasAutoRiskClassReduction,
    } = this.props;

    let looptijdrenteImage = '';
    if (this.props.forceAutoRiskClassReduction || this.props.selectedLabelHasAutoRiskClassReduction) {
      looptijdrenteImage = '/images/looptijdrente-logo-blue.png';
    } else {
      looptijdrenteImage = '/images/looptijdrente-logo-grey.png';
    }
    return (
      <div className="label-has-risk-class-reduction-logo">
        <div className="providertext">
          <LabelHasRiskClassReductionTextComponent
            selectedLabelHasAutoRiskClassReduction={selectedLabelHasAutoRiskClassReduction}
            forceAutoRiskClassReduction={forceAutoRiskClassReduction}
          />
        </div>
        <img className="riskClassReductionLogo" src={looptijdrenteImage} alt="looptijdrente" />
      </div>
    );
  }
}

LabelHasRiskClassReductionLogoComponent.propTypes = {
  selectedLabelHasAutoRiskClassReduction: PropTypes.bool,
  forceAutoRiskClassReduction: PropTypes.bool,
};

LabelHasRiskClassReductionLogoComponent.defaultProps = {
  selectedLabelHasAutoRiskClassReduction: false,
  forceAutoRiskClassReduction: false,
};

export default LabelHasRiskClassReductionLogoComponent;
